import React, { useEffect, useState } from "react";
import { fetchData } from "../axios_URL";
import "./CompanyTable.css";

import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
 
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
const Request = () => {
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null); // For viewing details
    
    const [acceptCompany, setAcceptCompany] = useState(null); // For viewing details
    const [confirmDelete, setConfirmDelete] = useState(null); // For delete confirmation
    const [refresh, setRefresh] = useState(false); // To trigger re-fetching

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const response = await fetchData("GET", "/api/admin/companies/request");
                setCompanies(response.data);
            } catch (error) {
                console.error("Error fetching companies:", error);
            }
        };

        fetchCompanies();
    }, [refresh]);

    const handleDelete = async (id) => {
        try {
            await fetchData("DELETE", `/api/admin/companies/request/${id}`);
            setConfirmDelete(null);
            window.location.reload();
            setRefresh((prev) => !prev); // Refresh list
        } catch (error) {
            console.error("Error deleting company:", error);
        }
    };

    const handlAccept = async (id) => {
        try {
            await fetchData("Post", `/api/admin/companies/request/accept/${id}`);
            setAcceptCompany(null);
            setRefresh((prev) => !prev); // Refresh list
            closeModal();
            window.location.reload();
        } catch (error) {
            console.error("Error accepting company:", error);
        }
    };
    const closeModal = () => {
        setSelectedCompany(null);
  
        setConfirmDelete(null);
 
    };

    return (
   
        <div className="content">
        <h1>Anfragen</h1>
        <div className="company-table">
            <table>
                <thead>
                    <tr>
                        <th>Firmenname</th>
                        <th>E-Mail</th>
                        <th>Mitarbeiter</th>
                        <th>Module</th>
                        <th>Status</th>
                        <th>Startdatum</th>
                        <th>Enddatum</th>
                        <th>Pakete</th>
                        <th>Kostentype</th>
                        <th>Aktionen</th>
                    </tr>
                </thead>
                <tbody>
                    {companies.map((company) => (
                        <tr key={company.id}>
                            <td>{company.companyname}</td>
                            <td>{company.companyemail}</td>
                            <td>{company.numberofemployee}</td>
                            <td>
                                {company.numberofpackage === 1 ? "Stempel Uhr" :
                                    company.numberofpackage === 2 ? "Planungs" :
                                        company.numberofpackage}
                            </td>
                            <td>
                                <span
                                    style={{
                                        color: company.status === "Active" ? "green" :
                                            company.status === "Pending" ? "orange" :
                                                company.status === "Stop" ? "red" : "black",
                                        fontSize: "20px",
                                    }}
                                >
                                    ●
                                </span>
                                {company.status === "Active" ? "Aktiv" :
                                    company.status === "Pending" ? "Ausstehend" :
                                        company.status === "Stop" ? "Gestoppt" : company.status}
                            </td>
                            <td>{company.startdate || "N/A"}</td>
                            <td>{company.enddate || "N/A"}</td>
                            <td>     {company.numberofemployee === 5 ? "Startpaket" :
                                    company.numberofemployee === 10 ? "Mediumpaket" :
                                        company.numberofemployee === 30 ? "Premiumpaket" : "Enterprise"}  </td>
                            <td>   
                                {company.costtype === "yearly" ? "jährlich" :
                                company.costtype === "monthly" ? "monatlich" : company.costtype}
                            </td>
                            <td>
                                <button onClick={() => setSelectedCompany(company)}><RemoveRedEyeIcon /></button>
                                <button onClick={() => setAcceptCompany(company)}><CheckCircleIcon /></button>
                                <button onClick={() => setConfirmDelete(company)}><DeleteForeverIcon /></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {selectedCompany && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modalscroll">
                            <div className="AddEmployeeHeader">Details des Unternehmens</div>

                            {[

                                { label: 'Firmenname', value: selectedCompany.companyname },
                                { label: 'E-Mail', value: selectedCompany.companyemail },
                                { label: 'Vorname', value: selectedCompany.firstname },
                                { label: 'NachName', value: selectedCompany.lastname },
                                { label: 'Telefonnummer', value: selectedCompany.telephone_number },
                                { label: 'Straße', value: selectedCompany.street },
                                { label: 'Postleitzahl', value: selectedCompany.postalCode },
                                { label: 'Stadt', value: selectedCompany.city },
                                { label: 'Region', value: selectedCompany.region },
                                { label: 'Land', value: selectedCompany.country },
                                { label: 'Zusätzliche Adresse', value: selectedCompany.additionaladdress },
                                { label: 'Status', value: selectedCompany.status },
                                { label: 'Anzahl der Mitarbeiter', value: selectedCompany.numberofemployee },
                                { 
                                    label: 'Pakete', 
                                    value: 
                                      selectedCompany.numberofemployee === 5 ? "Startpaket" :
                                      selectedCompany.numberofemployee === 10 ? "Mediumpaket" :
                                      selectedCompany.numberofemployee === 30 ? "Premiumpaket" : "Enterprise"
                                },
                                { label: 'Module', value: selectedCompany.numberofpackage === 1 ? 'Stempel Uhr' : selectedCompany.numberofpackage === 2 ? 'Planungs' : selectedCompany.numberofpackage },
                                { label: 'Erstellungsdatum', value: selectedCompany.createdate },
                                { label: 'Startdatum', value: selectedCompany.startdate },
                                { label: 'Enddatum', value: selectedCompany.enddate },
                         
                                { label: 'Aktiv', value: selectedCompany.active ? 'Yes' : 'No' }
                            ].map(({ label, value }) => (
                                <LabelValue key={label} label={label} value={value} />
                            ))}
                            <button onClick={() => handlAccept(selectedCompany.id)}>Test Starten</button>
                            <button className="close-button" onClick={closeModal}>Schließen</button>
                        </div>
                    </div>
                </div>
            )}
            {/* Delete Confirmation Popup */}
            {confirmDelete && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-content">
                            <h3>Bestätigung der Löschung</h3>
                            <p>Sind Sie sicher, dass Sie das Unternehmen "{confirmDelete.companyname}" löschen möchten?</p>
                            <div className="form-actions">
                                <button onClick={() => handleDelete(confirmDelete.id)}>Ja, löschen</button>
                                <button onClick={() => setConfirmDelete(null)}>Abbrechen</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
                  {acceptCompany && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-content">
                            <h3>Bestätigung der Testphase</h3>
                            <p>  Sind Sie sicher, dass Sie das Unternehmen"{acceptCompany.companyname}" in die Testphase bringen möchten?</p>
                            <div className="form-actions">
                                <button onClick={() => handlAccept(acceptCompany.id)}>Ja,  </button>
                                <button onClick={() => setAcceptCompany(null)}>Abbrechen</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
};

const LabelValue = ({ label, value }) => (
    <div className="form-group">
        <label><strong>{label}:</strong></label>
        <label>{value}</label>
    </div>
);
export default Request;
